export default "__VITE_ASSET__BkBzl$l7__"